import { Loading as UILoading } from "@webmotors/eleanor-ui";

export type LoadingProps = {
  variant?: "white" | "blue";
  size?: "small" | "medium" | "large";
  className?: string;
};

export function Loading({ ...props }: Readonly<LoadingProps>) {
  return <UILoading {...props} />;
}
